import React, { useEffect, useState, useRef } from "react";
import "./control.css";
import data from "../../json/cicontrolitems";

const Control = () => {

  const [videoActivo, setVideoActivo] = useState(null);
  const [activo, setActivo] = useState(null);
  const videoRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🔴 Pausar video al cerrar modal
  const cerrarModal = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    setVideoActivo(null);
  };

  // =================================================
  // 🔹 FUNCIÓN TOGGLE ACORDEÓN
  // =================================================
  const toggleAcordeon = (index) => {
    setActivo(activo === index ? null : index);
  };

  return (
    <div
      className="container-full-width cinterno-bg"
      style={{
        backgroundImage: `url(${data.background})`,
        backgroundSize: "30%",
        backgroundPosition: "center",
        backgroundRepeat: "repeat",
        width: "100%",
        minHeight: "100vh"
      }}
    >
      {/* ===== ENCABEZADO ===== */}
      <h3 className="title">
        Componentes de Control
      </h3>
      <hr className='hr-gob' />

      {/* ===== BARRA DE LINKS ===== */}
      <div className="subheader-links">
        {data.links?.map((link, index) => (
          <a key={index} href={link.url} className="link-custom">
            {link.texto}
          </a>
        ))}
      </div>

      {/* ========================================= */}
      {/* 🎥 SECCIÓN DE VIDEO */}
      {/* ========================================= */}
      {data.videos && data.videos.length > 0 && (
        <div className="video-section">

          {data.videos.map((item) => (
            <div className="video-block" key={item.id}>

              {/* TÍTULO DEL VIDEO */}
              {item.titulo && (
                <h4 className="video-title">{item.titulo}</h4>
              )}

              {/* VIDEO */}
              <div className="video-container">
                <video controls>
                  <source src={item.url} type="video/mp4" />
                  Tu navegador no soporta video.
                </video>
              </div>

            </div>
          ))}

        </div>
      )}

      {/* ===== MODAL VIDEO (si se usa) ===== */}
      {videoActivo && (
        <div
          className="modal-overlay"
          onClick={cerrarModal}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="modal-header">
              <h3>{videoActivo.titulo}</h3>
              <button
                className="btn-cerrar"
                onClick={cerrarModal}
              >
                ✕
              </button>
            </div>

            <video ref={videoRef} controls autoPlay>
              <source src={videoActivo.url} type="video/mp4" />
            </video>

          </div>
        </div>
      )}

      {/* ========================================= */}
      {/* 📂 ACORDEÓN - DEBAJO DEL VIDEO */}
      {/* ========================================= */}
      {data.acordeon && data.acordeon.length > 0 && (
        <div className="acordeon-container">

          {data.acordeon.map((item, index) => (
            <div key={index} className="acordeon-item">

              {/* TÍTULO DEL ACORDEÓN */}
              <div
                className={`acordeon-titulo ${activo === index ? 'activo' : ''}`}
                onClick={() => toggleAcordeon(index)}
              >
                <span>{item.titulo}</span>
                <span className="acordeon-icono">
                  {activo === index ? "−" : "+"}
                </span>
              </div>

              {/* CONTENIDO DEL ACORDEÓN */}
              <div
                className={
                  activo === index
                    ? "acordeon-contenido abierto"
                    : "acordeon-contenido"
                }
              >
                {item.archivos?.map((archivo, i) => (
                  <a
                    key={i}
                    href={archivo.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-pdf"
                  >
                    📄 {archivo.nombre}
                  </a>
                ))}
              </div>

            </div>
          ))}

        </div>
      )}

    </div>
  );
};

export default Control;